<template>
  <div class="truck flex-v-center">
    <div class="truck__picture flex-center">
      <img src="@/assets/img/new-truck-green.svg" alt="truck ">
    </div>
    <div class="truck__info">
      <div class="font-normal">Авто</div>
      <div class="truck__info-title">{{ auto.state_numbers }}</div>
    </div>
    <div v-if="auto.state_numbers_trailer" class="truck__info">
      <div class="font-normal">Прицеп</div>
      <div class="truck__info-title">{{ auto.state_numbers_trailer }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutoItem',
  props: {
    auto: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/styles/driver-styles.sass"
.truck
  padding: 1.6rem

  &__picture
    width: 4.6rem
    height: 4.6rem
    margin-right: 1.6rem
    background: #EBF9EB
    border-radius: .8rem
    img
      width: 2.4rem
      height: 2.4rem
  &__info
    width: 11.2rem
    margin-right: 2rem
    &-title
      margin-top: 0.4rem
      font-size: 1.6rem
      line-height: 2rem
      font-weight: 700
      color: #181818
</style>
